/*
 * Copyright 2026 Sony Corporation
 */
import { IconButton, Paper, Tooltip, Typography } from '@mui/material';

import { ChevronIcon } from './icons';

/** A side column folded to a thin strip: its name written down the side and a button to open it again. */
export const FoldedStrip = ({ label, side, onOpen }: { label: string; side: 'left' | 'right'; onOpen: () => void }) => (
  <Paper variant="outlined" component="section" aria-label={label} sx={{ height: '100%', py: 1, textAlign: 'center' }}>
    <Tooltip title={`Show ${label.toLowerCase()}`} placement={side === 'left' ? 'right' : 'left'}>
      <IconButton size="small" aria-label={`Show ${label.toLowerCase()}`} onClick={onOpen}>
        <ChevronIcon direction={side === 'left' ? 'right' : 'left'} fontSize="small" />
      </IconButton>
    </Tooltip>
    <Typography
      variant="overline"
      color="text.secondary"
      sx={{ display: 'block', writingMode: 'vertical-rl', mx: 'auto', mt: 1 }}
    >
      {label}
    </Typography>
  </Paper>
);

/** The button in a side column's header that folds it to a strip. */
export const FoldButton = ({ label, side, onFold }: { label: string; side: 'left' | 'right'; onFold: () => void }) => (
  <Tooltip title={`Hide ${label.toLowerCase()}`}>
    <IconButton size="small" aria-label={`Hide ${label.toLowerCase()}`} onClick={onFold}>
      <ChevronIcon direction={side} fontSize="small" />
    </IconButton>
  </Tooltip>
);
